<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <img :src="src" alt="" />
</template>

<script>
const images = import.meta.glob("../assets/*.svg", { eager: true });
export default {
  name: "PristyIcon",
  props: {
    svgFileName: {
      default: "",
      type: String,
    },
  },
  computed: {
    // Computed so the icon updates when svgFileName changes. PrimeVue reuses
    // row component instances across sort/pagination, so a created()-only
    // resolution would leave the icon stale and mismatched with its row.
    src() {
      const filename = this.svgFileName || "default";
      return (
        images[`../assets/${filename}.svg`]?.default ||
        images["../assets/default.svg"].default
      );
    },
  },
};
</script>

<style scoped></style>
